import { Directive } from '@angular/core';
import { SocialShareComponentDef } from '@df/ui/social/social-share.component.def';

@Directive()
export class SocialShareAbstract extends SocialShareComponentDef {}
